//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VALIDATION_TYPES from '~/constants/validation_type'
export default {
  name: 'ValidationTypeTag',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    isValidated() {
      return this.type === VALIDATION_TYPES.VALIDATED
    },
    isInvalidated() {
      return this.type === VALIDATION_TYPES.INVALIDATED
    },
    isNotRecognized() {
      return this.type === VALIDATION_TYPES.NOT_RECOGNIZED
    },
    isAdded() {
      return this.type === VALIDATION_TYPES.ADDED
    },
  },
}
